import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-delete-lotes',
  templateUrl: './modal-delete-lotes.component.html',
  styleUrls: ['./modal-delete-lotes.component.scss']
})
export class ModalDeleteLotesComponent {
 constructor(
    // Injeta o MatDialogRef para controlar o modal
    private dialogRef: MatDialogRef<ModalDeleteLotesComponent>, 
    // Injeta os dados passados ao abrir o modal, usando o decorador @Inject.
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}


  /**
   * Fecha o modal e retorna 'true' para indicar a confirmação da exclusão.
   */
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  /**
   * Fecha o modal e retorna 'false' (ou nada) para indicar o cancelamento.
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }
}
